import { useTranslation } from "react-i18next";
import { useState } from "react";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import { SignTypeValues } from "../../cubeComponent/constants";
import DropDownListComponent from "../../cubeComponent/form/DropdownListComponent";
import DrawSignature from "../UserSignature/DrawSignature";
import ImportSignature from "../UserSignature/ImportSignature";
import { useSelector } from "react-redux";

function Signature({ dataSource, defaultSelectedSignType, onSuccess, acceptFileType, showDropDown = true }) {
  const { t } = useTranslation();
  const [selectedSignType, setSelectedSignType] = useState(defaultSelectedSignType);
  const userDetails = useSelector((state) => state.userDetails);

  const changeSignTypeHandler = (e) => {
    onSuccess(e.value);
    setSelectedSignType(e.value);
  };

  const handleSignDocChange = async ({ base64ImageStr, fileType }) => {
    onSuccess({ base64ImageStr, fileType });
  };

  return (
    <div className="flex gap-5 flex-col w-full">
      {showDropDown && (
        <div className="flex">
          <DropDownListComponent
            fields={{ text: "name", value: "value" }}
            buttonType={BUTTON_TYPES.DROPDOWN_BACKGROUND_LIST}
            dataSource={dataSource}
            popupWidth="100%"
            value={defaultSelectedSignType}
            change={changeSignTypeHandler}
          />
        </div>
      )}
      <div className="flex w-full">
        {selectedSignType === SignTypeValues.ATTACH_SIGNED_DOCUMENT && (
          <ImportSignature handleSignDocChange={handleSignDocChange} acceptFileType={acceptFileType} />
        )}
        {selectedSignType === SignTypeValues.DRAW_ON_SCREEN && (
          <DrawSignature drawSignatureCallback={handleSignDocChange} />
        )}
        {selectedSignType === SignTypeValues.IMPORT_PROFILE_SIGNATURE &&
          (userDetails.signatureUrl ? (
            <img
              className="h-36 w-36 border-2 rounded-sg border-button_light"
              src={userDetails.signatureUrl}
              alt="Signature"
            />
          ) : (
            <p className="text-red-600">{t("Signature not found, please add to profile for import")}</p>
          ))}
      </div>
    </div>
  );
}
export default Signature;
